import { sv } from "@dhx/ts-common/dom";
import { getCoordinates, pieLikeHandlers } from "../helpers/circle";
import { verticalCenteredText } from "../helpers/common";
import { NoScaleSubType, SvgElement } from "../types";
import NoScaleSeria from "./NoScaleSeria";

export default class Donut extends NoScaleSeria {
	paint(width: number, height: number): SvgElement {
		const radius = height / 2;
		let currentPercent = -.25; // 0 percent is (1, 0) point, -.25 is (0, -1) point
		let svg = [];
		const links = [];

		const tooltipData = [];

		const err = this._points.length === 1 ? -.000001 : 0;
		this._points.forEach(item => {
			const [percent, value, id, text, color] = item;

			const [startX, startY] = getCoordinates(currentPercent, radius, radius);
			const avPercent = currentPercent + percent / 2;
			currentPercent += percent + err;
			const [endX, endY] = getCoordinates(currentPercent, radius, radius);
			const largeArcFlag = percent > .5 ? 1 : 0;
			const middleLine = getCoordinates(avPercent, radius, radius);
			const isRight = avPercent > - 0.25 && avPercent < 0.25;
			const isUp = avPercent > 0.5 || avPercent < 0;

			switch(this.config.subType) {
				case NoScaleSubType.basic: {
					const className =  isRight ? "donut-value-title start-text" : "donut-value-title end-text";
					const textPadding = 10;
					const dy = isUp ? -textPadding * 2 : textPadding;
					const linkStart = getCoordinates(avPercent, radius + 10, radius + 10);
					const className2 = isRight ? "donut-value start-text" : "donut-value end-text";
					const text1 = sv("text", {x: linkStart[0], y: linkStart[1] + dy, class: className}, [
						verticalCenteredText(text.toString())
					]);
					const text2 = sv("text", {x: linkStart[0], y: linkStart[1] + dy + 16, class: className2}, [
						verticalCenteredText(value.toString())
					]);
					links.push(text1);
					links.push(text2);
					break;
				}
				case NoScaleSubType.valueOnly: {
					const className =  isRight ? "donut-value start-text" : "donut-value end-text";
					const textPadding = 10;
					const dy = isUp ? -textPadding : textPadding;
					const linkStart = getCoordinates(avPercent, radius + 10, radius + 10);
					const textSvg = sv("text", {x: linkStart[0], y: linkStart[1] + dy, class: className}, [
						verticalCenteredText(text.toString())
					]);
					links.push(textSvg);
					break;
				}
				case NoScaleSubType.percentOnly:
					const percentText = sv("text", {x: middleLine[0] * 7 / 9, y: middleLine[1] * 7 / 9, class: "pie-inner-value"}, [
						verticalCenteredText(Math.round(percent * 100) + "%")
					]);
					links.push(percentText);
			}
			const d = `M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY} L 0 0`;
			const [shiftX, shiftY] = getCoordinates(avPercent, 4, 4);
			const currentSector = sv("path", {
				d,
				_key: id,
				fill: color,
				class: "chart donut",
				onmouseout: [pieLikeHandlers.onmouseout],
				onmouseover: [pieLikeHandlers.onmouseover, shiftX, shiftY]
			});

			svg.push(currentSector);

			if (this._points.length === 1) {
				tooltipData.push([width / 2, height / 2]);
			} else {
				tooltipData.push([middleLine[0] * .8 + width / 2, middleLine[1] * .8 + height / 2]);
			}
		});

		this._center = [width / 2, height / 2];
		this._tooltipData = tooltipData;

		svg.push(sv("circle",{
			cx: 0,
			cy: 0,
			r: radius * 5 / 9,
			fill: "#FFFFFF"
		}));
		svg = svg.concat(links);
		return sv("g", { transform: `translate(${width / 2}, ${height / 2})` }, svg);
	}
}